// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type LightBulb20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const LightBulb20CircleFilled: FC<LightBulb20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-1.063-4.44c.292.293.645.44 1.059.44.413 0 .768-.146 1.062-.438A1.44 1.44 0 0 0 13.5 18.5h-3c0 .413.146.766.438 1.06ZM9 16v1.5h6V16H9Zm-2.302-3.135A5.355 5.355 0 0 0 8.688 15h6.624a5.355 5.355 0 0 0 1.99-2.135c.465-.896.698-1.851.698-2.865 0-1.667-.583-3.083-1.75-4.25C15.083 4.583 13.667 4 12 4c-1.667 0-3.083.583-4.25 1.75C6.583 6.917 6 8.333 6 10c0 1.014.233 1.969.698 2.865Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default LightBulb20CircleFilled;
